import React from 'react';
import { Box } from '@mui/material';
import { brand } from '../../theme';

interface BrandMarkProps {
  size?: number | string;
  onDark?: boolean;
}

/** Shared PithPlay mark for navigation and branded application surfaces. */
const BrandMark: React.FC<BrandMarkProps> = ({ size = 36, onDark = false }) => (
  <Box
    aria-hidden="true"
    sx={{
      width: size,
      height: size,
      flexShrink: 0,
      display: 'grid',
      placeItems: 'center',
      overflow: 'hidden',
      borderRadius: '24%',
      // No percentage padding: CSS resolves `p: '3%'` against the PARENT's
      // width, so inside a wide header the inset swallowed the whole tile and
      // the mark rendered as an empty square. The inset is on the image instead.
      p: 0,
      backgroundColor: onDark ? brand.ivory : 'transparent',
      border: onDark ? '1px solid rgba(248, 245, 239, 0.22)' : 0,
      boxShadow: onDark ? '0 5px 16px rgba(0, 0, 0, 0.18)' : 'none',
    }}
  >
    <Box
      component="img"
      src="/brand/pithplay-mark-ui.png"
      alt=""
      draggable={false}
      sx={{
        width: onDark ? '88%' : '100%',
        height: onDark ? '88%' : '100%',
        objectFit: 'contain',
        display: 'block',
      }}
    />
  </Box>
);

export default BrandMark;
